var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"18","height":"20","viewBox":"0 0 18 20","fill":"red","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M16 0H2C0.9 0 0.00999999 0.9 0.00999999 2L0 20L4 16H16C17.1 16 18 15.1 18 14V2C18 0.9 17.1 0 16 0ZM6 9H4V7H6V9ZM10 9H8V7H10V9ZM14 9H12V7H14V9Z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }